export default __webpack_public_path__ + "595ff6fa6e8a07aa95d3f303b36b2193.png";